import baseService from '@common/services/base.service';
import store from '@common/store/store';

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;

let http = baseService(store, tbRoute);

const apidDef = {
  getParametroHabilitaMensagem() {
    const nomeParametro = 'HabilitaMensagem';
    return http.get(`/ParametroExterno/${nomeParametro}`);
  },
  getParametroMensagem() {
    const nomeParametro = 'Mensagem';
    return http.get(`/ParametroExterno/${nomeParametro}`);
  },
};

export default apidDef;
